import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="container mx-auto px-4 py-12 flex flex-col items-center justify-center min-h-[60vh] text-center">
      <h1 className="text-4xl md:text-5xl font-bold text-mypa-blue mb-4">
        {t("notFound.title")}
      </h1>
      <p className="text-xl mb-8 max-w-2xl">
        {t("notFound.subtitle")}
      </p>
      <Link to="/" className="bg-mypa-green text-white px-6 py-3 rounded-lg font-medium hover:bg-opacity-90 transition-colors">
        {t("notFound.button")}
      </Link>
    </div>
  );
};

export default NotFound;
